import { hydrateRoot } from 'react-dom/client';
import { MarketingRoot } from './MarketingRoot.js';
import { RevealsAfterHydration } from './motion/RevealsAfterHydration.js';
import './styles/globals.css';

// iOS Safari only applies :active (button press feedback) once the document
// has a touch listener.
document.addEventListener('touchstart', () => {}, { passive: true });

// Content already on screen at boot must not be hidden by the reveal system and
// faded back in: that blinks the prerendered page and delays LCP on slow phones.
// RevealsAfterHydration marks it revealed before `html.js` switches hiding on,
// and only after hydration, so React never sees attributes it did not render.
hydrateRoot(
  document.getElementById('root')!,
  <RevealsAfterHydration>
    <MarketingRoot />
  </RevealsAfterHydration>,
);
